const configurationKeys = {
    idleTimerConfig: ['idleTimerConfig'] as const,
}

export default configurationKeys